import { put, retry, all } from 'redux-saga/effects';
import { authClient } from '../api/Client';
import { reject, resolve } from '../api';
import * as types from '../constants';
import { NOTIFICATION } from '../constants';
import {
  errorNotification,
  showNotification,
  successNotification,
  simpleErrorNotification,
} from '../../shared-components/Notifications';

export function* requestPermission({ data }) {
  try {
    // eslint-disable-next-line no-unused-vars
    const res = yield retry(4, 500, authClient.Permission.request, {
      body: data,
    });

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.REQUEST_PERMISSION),
        payload: res?.data(),
      });
      showNotification(
        successNotification({
          statusCode: 200,
          message: 'Request sent',
        }),
      );
    } else {
      yield all([
        put({
          type: reject(types?.REQUEST_PERMISSION),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Requesting permission was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.REQUEST_PERMISSION),
  //     // payload: res.data(),
  //   });
  //   showNotification(
  //     successNotification({
  //       statusCode: 200,
  //       message: 'Request sent',
  //     }),
  //   );
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.REQUEST_PERMISSION),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(
  //         error,
  //         reject(types?.REQUEST_PERMISSION),
  //       ),
  //     }),
  //   ]);
  // }
}

export function* loadPermissions() {
  try {
    const res = yield retry(4, 500, authClient?.Permission?.list);

    if (
      res?.responseStatus === 200 ||
      res?.responseStatus === 201 ||
      res?.responseStatus === 204
    ) {
      yield put({
        type: resolve(types?.LOAD_PERMISSIONS),
        payload: res?.data(),
      });
      // showNotification(
      //   successNotification({
      //     statusCode: 200,
      //     message: 'Request sent',
      //   }),
      // );
    } else {
      yield all([
        put({
          type: reject(types?.LOAD_PERMISSIONS),
          res,
        }),
        showNotification(
          simpleErrorNotification({
            statusCode: res?.responseStatus,
            message:
              JSON.parse(res?.responseData)?.errors?.[0]?.message ??
              'Loading permissions was unsuccessful.',
          }),
        ),
      ]);
    }
  } catch (error) {}

  //   yield put({
  //     type: resolve(types?.LOAD_PERMISSIONS),
  //     payload: res?.data(),
  //   });
  // } catch (error) {
  //   yield all([
  //     put({
  //       type: reject(types?.LOAD_PERMISSIONS),
  //       error,
  //     }),
  //     put({
  //       type: NOTIFICATION?.ADD_NOTIFICATION,
  //       notification: errorNotification(error, reject(types?.LOAD_PERMISSIONS)),
  //     }),
  //   ]);
  // }
}
